"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _Positioner = _interopRequireDefault(require("../Positioner"));

var _List = _interopRequireDefault(require("../List"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var applyRef = function applyRef(ref, el) {
  if (ref && _typeof(ref) === 'object') ref.current = el;
  if (typeof ref === 'function') ref(el);
};

var _StyledList = (0, _styledComponents["default"])(_List["default"]).withConfig({
  displayName: "Menu___StyledList",
  componentId: "o8czi7-0"
})(["", ""], function (p) {
  return p._css;
});

var Menu = _react["default"].forwardRef(function (_ref, forwardedRef) {
  var target = _ref.target,
      open = _ref.open,
      position = _ref.position,
      children = _ref.children,
      onClose = _ref.onClose,
      portalRef = _ref.portalRef,
      props = _objectWithoutProperties(_ref, ["target", "open", "position", "children", "onClose", "portalRef"]);

  var listRef = _react["default"].useRef();

  var close = _react["default"].useCallback(function () {
    onClose && onClose();
  }, [onClose]);

  _react["default"].useEffect(function () {
    var handleClick = function handleClick(e) {
      if (listRef.current && listRef.current.contains(e.target)) {
        return;
      }

      if (target && target.contains(e.target)) {
        return;
      }

      close();
    };

    if (open) {
      document.addEventListener('mousedown', handleClick);
    }

    return function () {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [open]);

  return _react["default"].createElement(_Positioner["default"], {
    target: target,
    position: position,
    isShown: open,
    innerRef: listRef
  }, function (_ref2) {
    var _ref3 = _ref2.ref,
        style = _ref2.style,
        zIndex = _ref2.zIndex,
        css = _ref2.css,
        state = _ref2.state;
    return _react["default"].createElement(_StyledList, _extends({
      ref: function ref(el) {
        applyRef(_ref3, el);
        applyRef(portalRef, el);
        applyRef(forwardedRef, el);
      },
      style: style,
      zIndex: zIndex,
      "data-state": state,
      bg: "white",
      borderRadius: "4px",
      boxShadow: 4
    }, props, {
      _css: css
    }), children);
  });
});

Menu.defaultProps = {
  position: _constants.Position.BOTTOM
};
var _default = Menu;
exports["default"] = _default;